import { EXPLORER } from '@/util/enums/views.constants';
import ViewRef from '@/util/ViewRef';
import { UUID } from '@/types';
import DashboardRef from '@/util/DashboardRef';
import {
  changeDataPresentation,
  changeTab,
  importView,
  loadRowRequest,
} from '@/actions';
import { QUERY_RESULTS } from '@/components/ChartHolder.constants';

const EDIT_VIEW = 'edit';

export const getPath = (
  currentTab: string,
  dashboard: Nullable<DashboardRef>,
  rowRequestId: UUID,
  view: ViewRef,
  isSaved: boolean,
  dataView: string,
) => {
  const dataPresentation = dataView === QUERY_RESULTS ? EDIT_VIEW : dataView;

  switch (currentTab) {
    case EXPLORER:
      if (isSaved) {
        return `#v=${view.series()}`;
      }
      if (rowRequestId) {
        return `/row-request/${rowRequestId}/${dataPresentation}`;
      }
      break;
  }
  return '#';
};

export const checkIfValidUUID = (str: string) => {
  // Regular expression to check if string is a valid UUID
  const regexExp =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

  return regexExp.test(str);
};

export const parseParameters = (parameters: string) => {
  const query: Record<string, string> = {};
  const pairs = (
    parameters[0] === '?' ? parameters.substring(1) : parameters
  ).split('&');
  pairs.forEach((item) => {
    const pair = item.split('=', 2);
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  });
  return query;
};

export const prepareViews = (
  dispatch: F<F0>,
  hash?: string,
  initialRowRequest?: string,
  dataView?: string,
) => {
  if (initialRowRequest) {
    const hashRowsRequest = hash?.slice(4);
    const rowRequestId = initialRowRequest || hashRowsRequest;
    dispatch(changeTab(EXPLORER));
    dispatch(loadRowRequest(rowRequestId));
    if (dataView) {
      // @ts-expect-error: Migrate to TS.
      dispatch(changeDataPresentation(dataView));
    }
  } else if (hash?.startsWith('#v=')) {
    const viewSeriesId = hash.slice(3);
    dispatch(changeTab(EXPLORER));
    dispatch(importView(viewSeriesId));
  }
};
